export default "<div>\n\n    <router-outlet>\n    </router-outlet>\n\n</div>";